// src/connects/invite-members-dialog.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import { translate } from 'react-i18next'
import InviteMembersDialogStore from '../actions/invite-members-dialog-store'

export const mapStateToProps = (state, ownProps)=> {
  return {
    user: state.user.current,
    registrationUrl: state.registrationUrl.url
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      InviteMembersDialogStore.get((isHidden)=> {
        props.updateUI({ isHidden: !!isHidden })
      })
      dispatch(actions.getRegistrationUrl(props.group.group_id))
    },

    willUpdate: (props, nextProps)=> {
      if (props.group.group_id != nextProps.group.group_id) {
        dispatch(actions.getRegistrationUrl(nextProps.group.group_id))
      }

      if (!props.ui.active && !nextProps.ui.isHidden) {
        nextProps.updateUI({ active: true })
      }
    },

    setIsHiddenToStore: (isHidden)=> InviteMembersDialogStore.set(isHidden),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    active: false,
    isHidden: false,
  }}),
  lifecycle,
  translate(),
)


// WEBPACK FOOTER //
// ./src/connects/invite-members-dialog.js